<template>
 <div class="qwe">
   <div class="merchant-name">{{mName}}</div>
    <el-tabs  v-model="activeName2" type="card" @tab-click="handleClick">
        <el-tab-pane label="商户交易数据" name="first">
            <detail></detail>
        </el-tab-pane>
        <el-tab-pane label="提现数据" name="second">
            <deposit></deposit>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
/* 
    !!!!!!!!!!!!!!!!!!!!!这是商户管理的一级页面，我也不知道为啥叫detail
 */
import detail from "./detail"
import deposit from "./deposit"
  export default {
    data() {
      return {
        activeName2: 'first',
        mName:'111111'
      };
    },
    mounted() {
      this.mName = this.$route.query.name
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    },
    components: {
        detail,
        deposit
    }
  };
</script>
<style>
.qwe{
    background-color: #fff;
    /* padding-top: 20px; */
    padding-left: 20px;
}
.merchant-name{
  margin: 20px;
  color:  #30CE7E;
}
</style>



// WEBPACK FOOTER //
// src/pages/merchant/details.vue